module.exports = __webpack_public_path__ + "media/images/flower3-feb941fc8da9f341fc31a1c381de92d4.png";